import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalDialog, DialogTitle, DialogContent, Button, ModalClose, DialogActions} from '@mui/joy';

import MaterialForm from './MaterialForm';
import { Material } from 'domain';

const MaterialFormDialog = ({ open, onClose, onSave, material }) => {
    const [currentMaterial, setMaterial] = useState(new Material(material));
    const [errors, setErrors] = useState({});

    const handleChange = (key) => (evt, val) => {
        setMaterial(currentMaterial.set(key, val ?? evt?.target?.value));
        setErrors({ ...errors, [key]: undefined });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            await currentMaterial.inspect();
            onSave(currentMaterial);
        } catch (err) {
            const newErrors = err.inner.reduce((acc, curr) => {
                acc[curr.path] = curr.message;
                return acc;
            }, {});
            setErrors(newErrors);
        }
    };

    const handleClose = () => {
        currentMaterial.reset();
        setErrors({});
        onClose();
    };

    return (
        <Modal open={open}>
            <ModalDialog
                layout="center"
                variant="soft"
                aria-labelledby="modal-title"
                maxWidth={720}
                sx={{width:'80vw'}}
            >
                <ModalClose onClick={handleClose} />
                <DialogTitle id="modal-title">
                    {material ? `Edit ${currentMaterial.name || 'Material'}` : 'Add Material'}
                </DialogTitle>
                <DialogContent>
                    <MaterialForm
                        onSave={handleSubmit}
                        onChange={handleChange}
                        material={currentMaterial}
                        errors={errors} />
                </DialogContent>
                <DialogActions>
                    <Button variant="solid" color="primary" onClick={handleSubmit} disabled={!currentMaterial.isSavable() || !currentMaterial.isDirty()}>
                        Save
                    </Button>
                    <Button variant="plain" color="neutral" onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </ModalDialog>
        </Modal>
    );
};

MaterialFormDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    material: PropTypes.instanceOf(Material),
};

export default MaterialFormDialog;
